<template>
  <v-navigation-drawer
      app
      :value="cOpen"
      @input="onInput"
  >
    <v-list-item>
      <v-list-item-avatar>
        <v-icon
            x-large
            color="primary"
        >mdi-heart</v-icon>
      </v-list-item-avatar>
      <v-list-item-content>
        <v-list-item-title class="title">
          Handelt Gemeinsam
        </v-list-item-title>
        <v-list-item-subtitle>
          Digitale Schaufenster
        </v-list-item-subtitle>
      </v-list-item-content>
    </v-list-item>
    <v-divider />
    <v-list-item to="/">
      <v-list-item-avatar>
        <v-icon large>mdi-basket-outline</v-icon>
      </v-list-item-avatar>
      <v-list-item-content>
        <v-list-item-title>Angebote</v-list-item-title>
        <v-list-item-subtitle>Durchsuche die Angebote der Jenaer Läden...</v-list-item-subtitle>
      </v-list-item-content>
    </v-list-item>
    <v-list-item to="/register">
      <v-list-item-avatar>
        <v-icon large>mdi-briefcase-plus-outline</v-icon>
      </v-list-item-avatar>
      <v-list-item-content>
        <v-list-item-title>Eintragen</v-list-item-title>
        <v-list-item-subtitle>Mein unternehmen vorstellen</v-list-item-subtitle>
      </v-list-item-content>
    </v-list-item>
    <v-list-item to="/about">
      <v-list-item-avatar>
        <v-icon large>mdi-information-variant</v-icon>
      </v-list-item-avatar>
      <v-list-item-content>
        <v-list-item-title>Über uns</v-list-item-title>
        <!--<v-list-item-subtitle>Was ist 'handelt-gemeinsam'?</v-list-item-subtitle>-->
      </v-list-item-content>
    </v-list-item>
    <v-list-item to="/impressum">
      <v-list-item-avatar>
        <v-icon large>mdi-clipboard-outline</v-icon>
      </v-list-item-avatar>
      <v-list-item-content>
        <v-list-item-title>Impressum</v-list-item-title>
      </v-list-item-content>
    </v-list-item>
    <v-list-item to="/datenschutz">
      <v-list-item-avatar>
        <v-icon large>mdi-shield-outline</v-icon>
      </v-list-item-avatar>
      <v-list-item-content>
        <v-list-item-title>Datenschutz</v-list-item-title>
      </v-list-item-content>
    </v-list-item>
  </v-navigation-drawer>
</template>

<script>
export default {
  name: 'AppNavigationDrawer',
  computed: {
    cOpen () {
      return this.$store.getters['app/showNavDrawer']
    }
  },
  methods: {
    onInput (value) {
      this.$store.commit('app/setNavDrawerState', value)
    }
  }
}
</script>

<style scoped>
</style>
